import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-date-picker-bootstrap',
  templateUrl: './formly-date-picker-bootstrap.component.html',
  styleUrls: ['./formly-date-picker-bootstrap.component.scss'],
})
export class FormlyDatePickerBootstrapComponent extends FieldType {


  ngOnInit(): void {
  }

}
